export enum InviteWorkersModalType {
  InviteViaMessage = 'inviteViaMessage',
  InviteViaLink = 'inviteViaLink',
  UploadCsv = 'uploadCsv',
}
